(() => {
  if (window.dpsCommerceBound) return;
  window.dpsCommerceBound = true;
  const configNode = document.getElementById('DpsCommerceConfig');
  if (!configNode) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
  let cart = config.cart;
  let checkoutSent = false;
  const viewed = new Set();
  const allowed = () => {
    try { return window.Shopify?.customerPrivacy?.marketingAllowed?.() === true && window.Shopify?.customerPrivacy?.saleOfDataAllowed?.() === true; }
    catch (_) { return false; }
  };
  const track = (name, data) => {
    if (!allowed() || typeof window.fbq !== 'function') return false;
    window.fbq('track', name, data);
    return true;
  };
  const view = (guard) => {
    const variant = guard.variant;
    if (!variant || viewed.has(variant.id) || !guard.valid?.() || !Number.isFinite(Number(variant.price))) return;
    const name = guard.info?.querySelector('.product__title')?.textContent?.trim() || config.productName;
    if (track('ViewContent', {content_ids:[String(variant.id)],content_type:'product',value:Number(variant.price)/100,currency:config.currency,content_name:name})) viewed.add(variant.id);
  };
  const boundForms = new WeakSet();
  const bindView = (guard) => {
    if (guard.form && !boundForms.has(guard.form)) {
      boundForms.add(guard.form);
      guard.form.addEventListener('variant:change', () => queueMicrotask(() => view(guard)));
    }
    view(guard);
  };
  const bindViews = (root = document) => {
    if (root.matches?.('dps-product-guard')) bindView(root);
    root.querySelectorAll('dps-product-guard').forEach(bindView);
  };
  bindViews();
  new MutationObserver((records) => {
    const roots = new Set();
    records.forEach((record) => {
      if (!record.addedNodes.length) return;
      const productRoot = record.target.closest?.('product-info');
      if (productRoot) roots.add(productRoot);
      else record.addedNodes.forEach((node) => { if (node.nodeType === 1) roots.add(node); });
    });
    if (roots.size) queueMicrotask(() => roots.forEach((root) => {
      if (!document.contains(root)) return;
      for (let ancestor = root.parentElement; ancestor; ancestor = ancestor.parentElement) {
        if (roots.has(ancestor)) return;
      }
      bindViews(root);
    }));
  }).observe(document.documentElement, {childList:true,subtree:true});
  document.addEventListener('visitorConsentCollected', () => bindViews());
  document.addEventListener('dps:privacy-ready', () => bindViews());
  const loadPrivacy = () => {
    if (window.Shopify?.customerPrivacy) { bindViews(); return; }
    window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}], (error) => {
      if (!error) bindViews();
    });
  };
  loadPrivacy();
  window.addEventListener('load', loadPrivacy, {once:true});
  document.addEventListener('cart:updated', (event) => {
    const next = event.detail?.cart;
    if (next && Number.isFinite(next.total_price) && Number.isInteger(next.item_count)) cart = {total_price:next.total_price,item_count:next.item_count,currency:next.currency || config.currency};
  });
  document.addEventListener('submit', (event) => {
    if (event.submitter?.name !== 'checkout' || event.submitter.disabled) return;
    queueMicrotask(() => {
      if (event.defaultPrevented || checkoutSent || !cart || cart.item_count < 1 || !Number.isFinite(cart.total_price)) return;
      checkoutSent = track('InitiateCheckout', {value:cart.total_price/100,currency:cart.currency || config.currency,num_items:cart.item_count});
    });
  });
  // One theme-owned listener: successful response, never a click, is the conversion source.
  document.addEventListener('ajaxProduct:added', (event) => {
    if (!allowed()) return;
    const response = event.detail?.product;
    const requested = event.detail?.requestedItems;
    if (!response || response.status || !Array.isArray(requested) || !requested.length) return;
    const responseItems = Array.isArray(response.items) ? response.items : [response];
    const items = [];
    for (const request of requested) {
      if (!request || typeof request !== 'object' || !request.id) return;
      const quantity = Number(request.quantity || 0);
      const item = responseItems.find((entry) => entry && typeof entry === 'object' && String(entry.variant_id || entry.id) === String(request.id));
      const cents = Number(item?.final_price ?? item?.price);
      if (!item || !Number.isInteger(quantity) || quantity < 1 || !Number.isFinite(cents) || cents < 0) return;
      items.push({item_id:String(request.id),item_name:item.product_title || item.title || config.productName,item_brand:item.vendor || '',item_category:item.product_type || '',price:cents/100,quantity});
    }
    const value = Math.round(items.reduce((sum, item) => sum + item.price * item.quantity, 0) * 100) / 100;
    track('AddToCart', {content_ids:items.map(item => item.item_id),content_type:'product',value,currency:config.currency,num_items:items.reduce((sum,item) => sum + item.quantity,0)});
    if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true && Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ecommerce:null});
      window.dataLayer.push({event:'add_to_cart',ecommerce:{currency:config.currency,value,items}});
    }
  });
  window.addEventListener('pageshow', () => { checkoutSent = false; });
})();
